import { post } from "../lib/axios";
import { Capacitor } from "@capacitor/core";

export function handleCheckout(url:any) {
    window.location.href = url;
}


// async function handleStripNative() {

//     const payload = {
//         success_url:"http://localhost:3000/success",
//         cancel_url:"http://localhost:3000/cancel"
//     }

//     const response = await post({ 
//         url:,
//         data:payload
//     },true);

//     const { data, error } = response;
//     if(data) {
//         const { url } = data;
//         openInAppBrowser(url);
//     }

//     if(error) {
//         alert(JSON.stringify(error));
//     }

// }

// async function openInAppBrowser(url:string) {
//     const options:InAppBrowserOptions = {
//         location: 'no',
//         clearcache: 'yes',
//         zoom: 'yes',
//         toolbar: 'no',
//         closebuttoncaption: 'close'
//     };
//     const browserRef = InAppBrowser.create(url,"_blank",options);
//     const loadStartObserver = browserRef.on('loadstart');
//     try {
//         const observer = loadStartObserver.subscribe(event => {
//             const { url } = event;
//             if(url.includes('success')) {
//                 browserRef.close();
//                 alert("Success")
//                 observer.unsubscribe();
//             }
//             else if(url.includes('cancel')) {
//                 browserRef.close();
//                 alert("Cancel");
//                 observer.unsubscribe();
//             }
//         });
//     } catch(error) {
//         alert(JSON.stringify(error));
//     }
// }